<template>
    <layout v-bind:user="user" v-bind:brands="brands" v-bind:company="company" title="トークルーム設定" @selectList="displaySelectedBrand($event)">
        <main class="ly_main">
            <div class="wrap">
                <div class="inner">
                    <!--Heading-->
                    <h1 class="heading_page-title flex _y-center">
                        <div class="main"><span>トークルーム設定</span></div>
                    </h1><!--/.heading_page-title-->

                    <section>

                        <div class="dm_component _setting form_admin-container">

                            <div class="md_common-bl">
                                <div class="inner">

                                    <div class="control-wrap">

                                        <!-- ToggleBtn -->
                                        <div class="item form_toggle">
                                            <!-- TextRow -->
                                            <div class="text-row">
                                                <label class="text" for="dm-setting1">ごあいさつメッセージ</label>
                                            </div>
                                            <!-- InputRow -->
                                            <div class="input-row">
                                                <input type="checkbox" id="dm-setting1" v-bind:checked="first_message_set" v-on:change="changeDmTalkSet()">
                                                <label class="btn" for="dm-setting1">
                                                    <div class="circle"></div>
                                                    <div class="text _off">OFF</div>
                                                    <div class="text _on">ON</div>
                                                </label>
                                            </div>
                                        </div><!-- /ToggleBtn -->

                                        <p>マイセレクトルームに追加されたときに自動で送信されるメッセージです。ごあいさつメッセージを送信しない場合は、オフにしてください。</p>

                                    </div>

                                    <!--btn-link-wrap-->
                                    <div class="btn_link-wrap" style="padding-bottom: 2rem;" v-if="!first_message_set">
                                        <form v-on:submit.prevent="dmTalkSetPost">

                                            <!--LinkBtn - キャンセル -->
                                            <button type="button" v-on:click="cancelDmTalkSet" class="btn_link _cancel md_icon-text">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                                </div>
                                            </button>

                                            <!--LinkBtn - 決定アイコン -->
                                            <button class="btn_link md_icon-text _white">
                                                <div class="inner">
                                                    <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                                </div>
                                            </button>

                                        </form>
                                    </div><!--/.btn-link-wrap-->

                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        Register
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                                    <div class="register-wrap news_component">
                                        <div class="inner">

                                            <form v-on:submit.prevent="dmTalkSetPost">
                                                <!-- PostBody -->
                                                <div class="post-body">
                                                    <div class="item form_textarea">
                                                        <textarea maxlength="250" v-model="first_message" placeholder="" required></textarea>
                                                    </div>
                                                </div>

                                                <!--btn-link-wrap-->
                                                <div class="btn_link-wrap">

                                                    <!--LinkBtn - キャンセル -->
                                                    <button type="button" v-on:click="cancelDmTalkSet" class="btn_link _cancel md_icon-text">
                                                        <div class="inner">
                                                            <span><div class="icon"><SvgIconCancel /></div>キャンセル</span>
                                                        </div>
                                                    </button>

                                                    <!--LinkBtn - 決定アイコン -->
                                                    <button class="btn_link md_icon-text _white">
                                                        <div class="inner">
                                                            <span><div class="icon"><SvgIconCheck /></div>保存</span>
                                                        </div>
                                                    </button>

                                                </div><!--/.btn-link-wrap-->
                                            </form>

                                        </div>
                                    </div><!-- /.register-wrap -->


                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        Preview
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->
                                    <div class="preview-wrap talk_component">
                                        <div class="inner">

                                            <h3><span>プレビュー</span></h3>

                                            <div class="wrap">
                                                <div class="talk-inner">

                                                    <!-- Bubble -->
                                                    <div class="bubble-item">
                                                        <div class="avatar-wrap">
                                                            <img src="/img/smp/end-user-shop1.jpg" alt="" class="avatar">
                                                        </div>
                                                        <div class="bubble-wrap">
                                                            <div class="bubble-body">
                                                                <p><span>{{first_message}}</span></p>
                                                            </div>
                                                            <time>20xx/xx/xx 00:00</time>
                                                        </div>
                                                    </div>

                                                </div><!-- /TalkInner -->
                                            </div><!-- /Wrap -->

                                        </div>

                                    </div><!-- /.Preview-wrap -->
                                    <!--:::::::::::::::::::::::::::::::::::::::::::::::
                                        /Preview
                                    :::::::::::::::::::::::::::::::::::::::::::::::::-->

                                </div><!-- /.inner -->
                            </div><!-- /.md_common-bl -->

                        </div><!-- /.dm_component -->

                    </section>

                </div><!--/.ly_main .inner-->
            </div><!--/.ly_main .wrap-->
            <AlertModal 
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
            <div class="heading_page-title-en"><span>{{backName}}</span></div>
        </main>
    </layout>
</template>


<script>

    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    //Svg
    import SvgIconCancel from '@/components/EndUser/svg/SvgIconCancel'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "AlertModal": AlertModal,
            //Svg
            SvgIconCancel,
            SvgIconCheck,
        },
        data() {
            return {
                first_message_set: true,
                first_message: 'マイセレクトルームにご登録ありがとう御座います。このトークルームではオファー専門のトークルームになります。\n下記の条件を満たした内容の方のみのご返信とさせて頂きます。\n①価値軸が一緒\n②ビジネスの対象\n③小売の方\nその他\n※返信にお時間がかかるのでご了承下さい。\n※返信いただいた内容は他のお客さまには公開されません。',
                list_index: 0,
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                plan_validation: false,
            }
        },
        props: {
            user: Object,
            company: Object,
            brands: Object,
            brand: Object,
            listIndex: Object,
        },
        mounted() {
            if (this.brand.first_message_set) {
                $('.dm_component._setting .register-wrap').addClass('_on');
                $('.dm_component._setting .preview-wrap').addClass('_on');
            }

            this.first_message_set = this.brand.first_message_set;
            if (this.brand.first_message) {
                this.first_message = this.brand.first_message;
            }
            this.list_index = this.listIndex;
        },
        methods: {
            displaySelectedBrand(index) {
                var select_brand = this.brands[index];
                this.list_index = index;

                if (select_brand.plan == 1 && (select_brand.subscription_status == 'active' || select_brand.subscription_status == 'onGracePeriod')) {
                    this.list_index = index;
                    const form = reactive({
                        listIndex: this.list_index,
                    })
                    if (this.pageType == 1) {
                        Inertia.get(route('admin.brand.dm.talk.set', select_brand.id), form);
                    } else if (this.pageType == 2) {
                        Inertia.get(route('admin.showroom.dm.talk.set', select_brand.id), form);
                    }
                } else {
                    this.plan_validation = true;
                    this.openAlertModal('error', 'DMはBASICプランのみのご利用になります', 'DMはBASICプランのみのご利用になります。');
                }
            },
            dmTalkSetPost() {
                const form = reactive({
                    brand_id: this.brand.id,
                    first_message_set: this.first_message_set,
                    first_message: this.first_message,
                    listIndex: this.list_index,
                })
                if (this.pageType == 1) {
                    var url = '/admin/brand/dm/talk/set';
                } else if (this.pageType == 2) {
                    var url = '/admin/showroom/dm/talk/set';
                }
                Inertia.post(url, form, {
                    preserveScroll: true,
                    onSuccess: (page) => {
                        this.openAlertModal("success", "保存が完了しました", '保存が完了しました。'); //確認済み
                    },
                })
            },
            changeDmTalkSet() {
                var id = 'dm-setting1';
                var check = document.getElementById(id).checked;
                this.first_message_set = check;

                if ( check == false ) {
                    $('.dm_component._setting .register-wrap').removeClass('_on');
                    $('.dm_component._setting .preview-wrap').removeClass('_on');
                } else {
                    $('.dm_component._setting .register-wrap').addClass('_on');
                    $('.dm_component._setting .preview-wrap').addClass('_on');
                }
            },
            cancelDmTalkSet() {
                const form = reactive({
                    listIndex: this.list_index,
                })
                if (this.pageType == 1) {
                    var url = '/admin/brand/dm';
                } else if (this.pageType == 2) {
                    var url = '/admin/showroom/dm';
                }
                Inertia.get(url, form)
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';

                if (this.plan_validation){
                    if (this.pageType == 1) {
                        Inertia.get(route('admin.brand.dashboard'))
                    } else if (this.pageType == 2) {
                        Inertia.get(route('admin.showroom.dashboard'))
                    }
                }
            }
        },
        computed: {
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
            pageType() {
                var url = location.pathname;
                if (url.indexOf( '/admin/brand/dm/talk/set' ) != -1) {
                    return 1;
                } else if (url.indexOf( '/admin/showroom/dm/talk/set' ) != -1) {
                    return 2;
                }
            },
        },
    }
</script>

<style>
p {
    white-space: pre-wrap;
}
</style>